// extracted by mini-css-extract-plugin
module.exports = {"bf-wrapper":"_1EwKL","bf-text":"_2vcu7","bf-attribution":"_3L-5p"};